// MicrophoneButton.js
// UI component for the microphone button

import React from "react";

const MicrophoneButton = ({ baseUrl }) => {
    return (
        <div className="absolute bottom-0 left-0 w-full flex justify-center py-6 bg-[#F9F9F9]">
            <div className="relative flex items-center justify-center">
                <div className="absolute w-48 h-48 bg-gray-300 rounded-full opacity-80 animate-ping delay-100"></div>
                <div className="absolute w-32 h-32 bg-gray-400 rounded-full opacity-50 animate-ping delay-200"></div>
                <div className="absolute w-16 h-16 bg-[#170A1C] rounded-full opacity-10 animate-ping delay-400"></div>

                <button className="relative w-14 h-14 bg-black rounded-full flex items-center justify-center shadow-xl">
                    <img src={`${baseUrl}/images/icon_park_solid_voice.svg`} alt="Mic" className="w-6 h-6" />
                </button>
            </div>
        </div>
    );
};

export default MicrophoneButton;